/**
 * @description Hook utilizado para manipular os arquivos do sistema
 * @author Diego Sabino Amorim de Araújo
 * @file useArquivoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { downloadURL } from 'utils/helpers'
import { useFetch } from './useFetch'

export const useArquivoService = () => {
  const fetch = useFetch()

  const listarArquivo = async (rota, id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`${rota}/${id}`)
      return {
        arquivo: response.data.arquivo,
        mimetype: response.data.mimetype,
        nomeOriginal: response.data.nomeOriginal,
      }
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const uploadArquivo = async (rota, content, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.postOpen(rota, content)
      return response.data.arquivo
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const uploadArquivoGaleria = async (content, tipo, idObjeto) => {
    try {
      const response = await fetch.postOpenWithoutFeedback(`arquivo/galeria/${tipo}/${idObjeto}`, content)
      return response.data.id
    } catch (err) {
      console.log('erro ao fazer upload do arquivo', err)
    }
  }

  const deletarArquivo = async (rota, id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.del(`${rota}/${id}`)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const deletarFotoGaleria = async (id) => {
    try {
      await fetch.del(`arquivo/galeria/${id}`)
    } catch (err) {
      console.log(err)
    }
  }

  const downloadArquivo = async (rota, id, nome, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.getWithOptions(`${rota}/download/${id}`, {
        responseType: 'blob',
      })

      const fileURL = URL.createObjectURL(response.data)
      downloadURL(fileURL, nome)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const uploadSVGCalunga = async (svg, name) => {
    try {
      const formData = new FormData()
      const svgBlob = new Blob([svg], { type: 'image/svg+xml' })
      formData.append('file', svgBlob, name)
      const response = await fetch.postOpenWithoutFeedback('/arquivo/exame', formData)
      return response
    } catch (err) {
      return
    }
  }

  const dataURLToBlob = (dataUrl) => {
    const [header, base64] = dataUrl.split(',')
    const mime = header.match(/:(.*?);/)[1]
    const binary = atob(base64)
    const array = new Uint8Array(binary.length)

    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i)
    }

    return new Blob([array], { type: mime })
  }

  const uploadMapaOdonto = async (dataUrl, idExameNecrodontoscopico) => {
    try {
      const blob = dataURLToBlob(dataUrl)
      const formData = new FormData()
      formData.append('file', blob, `mapa-odonto${idExameNecrodontoscopico}.png`)
      const response = await fetch.postOpenWithoutFeedback('/arquivo/exame', formData)
      console.log(response)
      return response
    } catch (err) {
      console.log(err)
      return
    }
  }

  const fetchMetaDadosFotos = async (tipo, id, index, tamanhoIntervalo) => {
    try {
      const response = await fetch.getWithoutFeedback(`arquivo/galeria/metadados/${tipo}/${id}/${index}/${tamanhoIntervalo}`)
      return response.data.metaDados
    } catch (err) {
      console.log('erro ao carregador fotos', err)
      throw err
    }
  }

  const obterTotalFotosGaleria = async (tipo, id) => {
    try {
      const response = await fetch.getWithoutFeedback(`arquivo/galeria/quantidade/${tipo}/${id}`)
      return response.data.total
    } catch (err) {
      console.log('erro ao obter total de fotos', err)
      throw err
    }
  }

  return { 
    listarArquivo, 
    uploadArquivo, 
    deletarArquivo, 
    downloadArquivo, 
    uploadSVGCalunga, 
    uploadMapaOdonto, 
    dataURLToBlob, 
    fetchMetaDadosFotos, 
    uploadArquivoGaleria, 
    deletarFotoGaleria,
    obterTotalFotosGaleria
  }
}
